require('./redesign/sidebar');
require('./redesign/inputs');